module.exports = __webpack_public_path__ + "static/media/Biotif-Regular.66110a4e.ttf";